export interface ExampleFile {
  label: string;
  url: string;
}

export const exampleFilesByProduct: Record<string, ExampleFile[]> = {
  'postnummermitt-5': [
    { label: 'CSV / SWEREF99 TM', url: '/examples/se_pnrmitt5_a-CSV-SWEREF_example.zip' },
    { label: 'CSV / WGS84', url: '/examples/se_pnrmitt5_a-CSV-WGS84_example.zip' },
    { label: 'XLSX / SWEREF99 TM', url: '/examples/se_pnrmitt5_a-EXCEL-SWEREF_example.zip' },
    { label: 'XLSX / WGS84', url: '/examples/se_pnrmitt5_a-EXCEL-WGS84_example.zip' },
  ],
  'postnummerytor-5': [
    { label: 'GeoJSON / WGS84', url: '/examples/pnryta_se5-GEOJSON-WGS84_example.zip' },
    { label: 'Google KML', url: '/examples/pnryta_se5-GOOGLE-KML_example.zip' },
    { label: 'Shapefile / SWEREF99 TM', url: '/examples/pnryta_se5-SHAPE-SWEREF_example.zip' },
    { label: 'Shapefile / WGS84', url: '/examples/pnryta_se5-SHAPE-WGS84_example.zip' },
  ],
  'postnummermitt-lk': [
    { label: 'CSV / SWEREF99 TM', url: '/examples/se_pnrmitt5LK-CSV-SWEREF_example.zip' },
    { label: 'CSV / WGS84', url: '/examples/se_pnrmitt5LK-CSV-WGS84_example.zip' },
    { label: 'XLSX / SWEREF99 TM', url: '/examples/se_pnrmitt5LK-EXCEL-SWEREF_example.zip' },
    { label: 'XLSX / WGS84', url: '/examples/se_pnrmitt5LK-EXCEL-WGS84_example.zip' },
  ],
  'adressfilen': [
    { label: 'CSV / UTF-8', url: '/examples/rec1_v1-CSV-UTF8_example.zip' },
    { label: 'TEXT / ISO 8859-1', url: '/examples/rec1_v1-TEXT-8859-1_example.zip' },
  ],
  'adressfilen-lkd': [
    { label: 'CSV / UTF-8', url: '/examples/rec1lkd_v1-CSV-UTF8_example.zip' },
    { label: 'TEXT / ISO 8859-1', url: '/examples/rec1lkd_v1-TEXT-8859-1_example.zip' },
  ],
  'adressfilen-lkf': [
    { label: 'CSV / UTF-8', url: '/examples/rec1lkf_v1-CSV-UTF8_example.zip' },
    { label: 'TEXT / ISO 8859-1', url: '/examples/rec1lkf_v1-TEXT-8859-1_example.zip' },
  ],
  'adressfilen-lan-kommun-forsamling-distrikt': [
    { label: 'CSV / UTF-8', url: '/examples/se_rec1LKFD-CSV-UTF8_example.zip' },
    { label: 'TEXT / ISO 8859-1', url: '/examples/se_rec1LKFD-TEXT-8859-1_example.zip' },
  ],
  'postnummerfilen': [
    { label: 'CSV / UTF-8', url: '/examples/se_rec2-CSV-UTF8_example.zip' },
    { label: 'XLSX / UTF-8', url: '/examples/se_rec2-EXCEL-UTF8_example.zip' },
    { label: 'TEXT / ISO 8859-1', url: '/examples/se_rec2-TEXT-8859-1_example.zip' },
  ],
  'postnummerfilen-lk': [
    { label: 'CSV / UTF-8', url: '/examples/se_rec2LK-CSV-UTF8_example.zip' },
    { label: 'TEXT / ISO 8859-1', url: '/examples/se_rec2LK-TEXT-8859-1_example.zip' },
  ],
  'postnummerfilen-lkf': [
    { label: 'CSV / UTF-8', url: '/examples/se_rec2LKF-CSV-UTF8_example.zip' },
    { label: 'XLSX / UTF-8', url: '/examples/se_rec2LKF-EXCEL-UTF8_example.zip' },
    { label: 'TEXT / ISO 8859-1', url: '/examples/se_re2LKF-TEXT-8859-1_example.zip' },
  ],
  'postnummerfilen-lkd': [
    { label: 'CSV / UTF-8', url: '/examples/se_rec2LKD-CSV-UTF8_example.zip' },
    { label: 'XLSX / UTF-8', url: '/examples/se_rec2LKD-EXCEL-UTF8_example.zip' },
    { label: 'TEXT / ISO 8859-1', url: '/examples/se_rec2LKD-TEXT-8859-1_example.zip' },
  ],
  'postnummerfilen-brev-paket': [
    { label: 'CSV / UTF-8', url: '/examples/rec3_v3-CSV-UFF8_example.zip' },
    { label: 'XLSX / UTF-8', url: '/examples/rec3_v3-EXCEL-UTF8_example.zip' },
    { label: 'TEXT / ISO 8859-1', url: '/examples/rec3_v3-TEXT-8859-1_example.zip' },
  ],
  'adressfilen-forandringar': [
    { label: 'CSV / UTF-8', url: '/examples/se_rec4-CSV-UTF8_example.zip' },
    { label: 'TEXT / ISO 8859-1', url: '/examples/se_rec4-TEXT-8859-1_example.zip' },
  ],
  'adressfilen-lk-forandringar': [
    { label: 'CSV / UTF-8', url: '/examples/se_rec4LK-CSV-UTF8_example.zip' },
    { label: 'TEXT / ISO 8859-1', url: '/examples/se_rec4LK-TEXT-8859-1_example.zip' },
  ],
  'postnummerfilen-logistik': [
    { label: 'CSV / UTF-8', url: '/examples/rec6LK-CSV-UTF8_example.zip' },
    { label: 'XLSX / UTF-8', url: '/examples/rec6LK-EXCEL-UTF8_example.zip' },
    { label: 'TEXT / ISO 8859-1', url: '/examples/rec6LK-TEXT-8859-1_example.zip' },
  ],
};
